import { IconAngleLeft } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { FormattedMessage } from 'react-intl';

import LinkDebitCard from '../../../modals/addPaymentMethodModal/linkDebitCard/LinkDebitCard';
import { ONBOARDING_PATHS } from '../../constants';

export const AddPaymentMethod = () => {
    return (
        <div className="my-2xl">
            <NEW_IwLink to={{ pathname: ONBOARDING_PATHS.ONBOARDING_CHECKS }}>
                <Text className="mb-xl flex flex-row gap-xs text-s font-bold text-primary-40">
                    <IconAngleLeft className="my-auto" />
                    <FormattedMessage
                        id="_.credit_card.onboarding.payment_method.back_link"
                        defaultMessage="Back to list"
                    />
                </Text>
            </NEW_IwLink>
            <Text className="text-3xl font-bold">
                <FormattedMessage
                    id="_.credit_card.onboarding.payment_method.title"
                    defaultMessage="Set up your payments"
                />
            </Text>
            <Text className="my-m text-xl font-reg">
                <FormattedMessage
                    id="_.credit_card.onboarding.payment_method.description"
                    defaultMessage="Add a debit card to use for repayments and tell us how you’d like to repay each month."
                />
            </Text>
            <LinkDebitCard />
        </div>
    );
};
